export const PERMISSION = {
  BATCH: 'BATCH',
  BATCH_AI: 'BATCH_AI',
  BATCH_AI_2: 'BATCH_AI_2',
  BATCH_DEVICE: 'BATCH_DEVICE',
  BATCH_REMOTE: 'BATCH_REMOTE',
  BATCH_PROXY: 'BATCH_PROXY',
  BATCH_MODIFY_MIX_DESIGN_QUANTITY: 'BATCH_MODIFY_MIX_DESIGN_QUANTITY',
};

export class User {
  constructor(user = {}) {
    this.language = user.language || 'en-US';
    this.super = user.super || false;
    this.id = user.id;
    this.login = user.login;
    this.name = user.name;
    this.email = user.email;
    this.divisionId = user.divisionId;
    this.ianaTimezone = user.ianaTimezone;
    this.employeeId = user.employeeId;
    this.roleIds = user.roleIds;
    this.groupId = user.groupId;
    this.forcePasswordChange = user.forcePasswordChange;
    this.messengerAutostart = user.messengerAutostart;
    this.permissions = user.permissions || [];
  }

  /**
   * Has access
   * @param {PERMISSION|string} permission
   * @returns {boolean}
   */
  hasAccess(permission) {
    return this.permissions.includes(permission);
  }
}
